import React from "react";
import { useCompanyDashboard } from "../../Hooks/useCompanyDashboard";

export default function BusinessPerformance() {
  const { invoicesSummary, isLoading, isError } = useCompanyDashboard();

  if (isLoading) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 animate-pulse">
        <div className="h-8 bg-gray-200 rounded w-64 mb-5" />
        <div className="space-y-4">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-20 bg-gray-200 rounded-xl" />
          ))}
        </div>
      </div>
    );
  }

  if (isError || !invoicesSummary.recent_invoices?.length) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 text-center text-gray-500">
        No receivables data available.
      </div>
    );
  }

  const totalReceivables = invoicesSummary.formatted_total_profit;
  const clientCount = invoicesSummary.recent_invoices.length;

  // دالة مساعدة لعرض اسم العميل بشكل آمن
  const getClientName = (invoice) => {
    const client = invoice.user;
    if (!client) return "Unknown Client";
    return `${client.name || ""} `.trim() || "Unknown Client";
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-lg font-semibold text-gray-800">Business Performance</h3>
      </div>

      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <p className="font-medium text-gray-900">Receivables</p>
          <p className="text-sm text-gray-600">{clientCount} clients owe you</p>
        </div>
        <p className="text-2xl font-bold text-[#1665f6] mb-2">${totalReceivables}</p>
        <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-[#1665f6] to-[#0d51d4] w-full" />
        </div>
      </div>

      <div className="space-y-3">
        {invoicesSummary.recent_invoices.length > 0 ? (
          invoicesSummary.recent_invoices.slice(0, 5).map((invoice, i) => (
            <div 
              key={invoice.id || i} 
              className="flex items-center justify-between p-3 rounded-xl bg-gray-50 hover:bg-gray-100 transition"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-gray-400 to-gray-500 flex items-center justify-center text-white font-bold text-sm">
                  {getClientName(invoice)
                    .split(" ")
                    .map(n => n[0])
                    .join("")
                    .slice(0, 2)
                    .toUpperCase() || "CL"}
                </div>
                <div>
                  <p className="font-medium text-gray-900 text-sm">
                    {getClientName(invoice)}
                  </p>
                  {invoice.is_overdue && (
                    <p className="text-xs text-red-600 font-medium">Late</p>
                  )}
                </div>
              </div>
              <div className="text-right">
                <p className="font-semibold text-gray-900">
                  ${invoice.formatted_total || invoice.total || "0.00"}
                </p>
                {invoice.is_overdue && (
                  <p className="text-xs text-red-600">Past due</p>
                )}
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-gray-500 py-4">No recent invoices</p>
        )}
      </div>
    </div>
  );
}